<template>
  <b-modal
    id="purchase-seats-quickbooks"
    ref="purchase-seats-quickbooks"
    size="invite-member"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head seats">
      <h2 class="modal-title">
          {{label.get('subscription_purchase_additional_seats')}}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar v-if="invites.length > 0">
        <p class="seats-desc">
            {{label.get('subscription_purchase_additional_seats_description')}}
        </p>
        <div class="head-labels">
          <div class="label email">
            <p>
                {{label.get('email')}}
            </p>
          </div>
          <div class="label">
            <p>
                {{label.get('role')}}
            </p>
          </div>
        </div>
        <div
          v-for="(item, idx) in invites"
          :key="idx"
          class="field-row"
        >
          <div class="email-wrap">
            <input
              v-model="item.email"
              type="email"
              :class="{ error: item.error }"
              :placeholder="label.get('enter_email_address')"
              class="atto-input"
            >
          </div>
          <div class="role-wrap">
            <select-dropdown-component
              :value="item.role"
              :index="idx"
              placeholder="Select Role:"
              :options="roles"
              @onOptionSelected="onRoleSelected"
            />
          </div>
          <button
            v-if="!item.deleting"
            class="delete-member"
            @click="deleteInvite(item)"
          >
            <i class="atto atto-delete" />
          </button>
          <transition
            v-if="!item.deleting"
            name="fade"
          >
            <div
              v-if="item.confirm_delete"
              class="confirm-delete"
            >
              <span class="confirm-msg">{{label.get('are_you_sure')}}</span>
              <button
                class="confirm-delete-btn"
                @click="confirmDelete(item)"
              >
                  {{label.get('delete')}}
              </button>
              <button
                class="cancel-delete"
                @click="cancelConfirmDelete(item)"
              >
                <i class="atto atto-close-btn" />
              </button>
            </div>
          </transition>
        </div>
      </perfect-scrollbar>
      <div class="additional-seats-form">
        <div class="form-head quickbooks">
            <span class="no">{{label.get('subscription_number_of_users')}}</span>
            <span class="price">{{label.get('subscription_price_per_user')}}</span>
            <span class="total">{{label.get('subscription_total_amount')}}</span>
        </div>
        <div class="form-fields">
          <span class="price">{{ seats }}</span>
          <span class="price">${{ proratedCostPerUser.toFixed(2) }}</span>
          <span class="total">${{ totalAmount }}</span>
        </div>
        <span
          v-if="error"
          class="error-message"
        >{{ errorMessage }}</span>
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-disclaimer top">
        <p>
            {{label.get('subscription_purchase_additional_seats_prorated_amount')}}
        </p>
      </div>
      <div class="form-buttons">
        <button
          type="reset"
          class="atto-btn cancel"
          @click="close"
        >
            {{label.get('cancel')}}
        </button>
        <button
          type="submit"
          class="atto-btn submit"
          @click="purchaseSeats"
        >
            {{label.get('subscription_complete_purchase')}}
        </button>
      </div>
      <div class="form-disclaimer bottom">
        <p class="disclaimer">
            {{label.get('subscription_purchase_additional_seats_description_one')}}
        </p>
        <p>
            {{label.get('subscription_purchase_additional_seats_description_two')}}
        </p>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import {required} from 'vuelidate/lib/validators'
    import SelectDropdownComponent from '../../../../shared/components/SelectDropdownComponent';
    import BillingService from '../../billing/services/BillingService';
    import InviteService from '../../../../shared/services/InviteService';

    export default {
        name: "PurchaseSeatsQuickBooksComponent",
        components: {
            SelectDropdownComponent
        },
        props: {
            proratedCostPerUser: {
                type: Number,
                default: 5
            },
            isFirstPurchaseStripeTax: {
                type: Boolean,
                default: false
            },
            quantity: {
                type: Number,
                default: 1
            },
            activeUsers: {
                type: Number,
                default: 1
            },
            invites: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        data() {
            return {
                seats: this.invites.length > 0 ? this.invites.length : 1,
                min: 1,
                max: 999,
                error: false,
                payInvoiceRetryCount: 1,
                roles: [
                    {
                        value: 1,
                        label: this.label.get('admin')
                    },
                    {
                        value: 2,
                        label: this.label.get('manager')
                    },
                    {
                        value: 3,
                        label: this.label.get('employee')
                    }
                ]
            }
        },
        computed: {
            totalAmount() {
                if (this.seats === null || this.seats === '') {
                    return ' - ';
                }
                return (this.seats * this.proratedCostPerUser).toFixed(2);
            }
        },
        watch: {
            seats(newVal, oldVal) {
                const val = parseInt(newVal);
                if (!isNaN(val) && !isNaN(oldVal) && (val > 999 || val < 1)) {
                    this.seats = parseInt(oldVal);
                }

                if (val === 0) {
                    this.seats = '';
                }
                this.error = false;
            }
        },
        validations: {
            seats: {
                required
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['purchase-seats-quickbooks'].show();
        },
        methods: {
            close() {
              const quickBooksParam = this.$route.query.quickbook;
              var quickbookConnected = false;
              if (quickBooksParam !== undefined) {
                quickbookConnected = true;
              }
              this.$root.$emit('hidePurchaseSeatsQuickBooks', {
                quickbookConnected : quickbookConnected
              });
            },

            onRoleSelected(option, index) {
                this.invites[index].role = option.value;
            },

            deleteInvite(item) {
                item.confirm_delete = true;
            },
            confirmDelete(item) {
                item.deleting = true;
                InviteService.deleteInvite(item.id).then((result) => {
                    const index = this.invites.indexOf(item);
                    this.invites.splice(index, 1);
                    this.seats = this.invites.length === 0 ? 1 : this.invites.length;
                }).catch((error) => {
                    item.deleting = false
                });
            },
            cancelConfirmDelete(item) {
                item.confirm_delete = false;
            },

            purchaseSeats() {

                this.error = false;
                this.errorMessage = '';
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.errorMessage = this.label.get('subscription_please_enter_the_number_of_seats');
                    this.error = true;
                    return;
                }

                this.resetErrors();
                if (!this.validateEmails()) {
                    this.errorMessage = this.label.get('please_add_a_valid_email');
                    this.error = true;
                    return;
                }

                if (this.seats < 1 || this.seats > 999) {
                    this.errorMessage = this.label.get('subscription_please_enter_a_valid_number_of_seats');
                    this.error = true;
                    return;
                }

                this.$store.commit('showLoading');
                BillingService.purchaseSeats({
                    invites: this.invites,
                    seats: this.seats,
                    isFirstPurchaseStripeTax: this.isFirstPurchaseStripeTax
                }).then((result) => {
                  //this.payInvoice(result.data.invoice_id);
                  this.$store.commit('hideLoading');
                  this.$awn.success(result.data.message);
                  const quickBooksParam = this.$route.query.quickbook;
                  this.$root.$emit('hidePurchaseSeatsQuickBooks', {
                    quickbookConnected : quickBooksParam !== undefined
                  });
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                    this.errorMessage = error.response.data.error.message;
                    this.error = true;
                });
            },

          payInvoice(invoiceId) {
            debugger;
            BillingService.payInvoice({
              invoice_id: invoiceId,
              retry_count: this.payInvoiceRetryCount
            }).then((result) => {
              this.$store.commit('hideLoading');
              this.$awn.success(result.data.message);
              const quickBooksParam = this.$route.query.quickbook;
              this.$root.$emit('hidePurchaseSeatsQuickBooks', {
                quickbookConnected : quickBooksParam !== undefined
              });
            }).catch((error) => {
              debugger;
              console.log(error.response);
              if(error.response.status !== 423) {
                this.$store.commit("hideLoading");
                this.errorMessage = error.response.data.message;
                this.error = true;
              } else if(this.payInvoiceRetryCount < 10) {
                this.payInvoiceRetryCount++;
                setTimeout(() => {
                  this.payInvoice(invoiceId);
                }, 1000);
              }
            });
          },

            resetErrors() {
                this.invites.forEach((item) => {
                    item.error = false;
                });
            },
            validateEmails() {
                let validEmails = true;
                const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                this.invites.forEach((item) => {
                    if (item.email.trim() !== '' && !regex.test(item.email.trim())) {
                        item.error = true;
                        validEmails = false;
                    }
                });

                return validEmails;
            }
        }
    }
</script>

<style lang="scss">

    .modal-invite-member {

        .modal-head {
            padding: 40px 40px 8px;
            position: relative;

            h2.modal-title {
                font-family: "Roboto", sans-serif;
                font-weight: 500;
                font-size: 1.25rem;
                line-height: 1.75rem;
                color: #262626;
            }

            a.manage-team-anchor {
                position: absolute;
                right: 48px;
                top: 48px;
                width: 160px;
                font-size: 0.875rem;
                line-height: 1.5rem;
                font-family: $roboto-font;
                color: $atto-font-color;
                font-weight: 500;
                @include base-transition(ease color 0.15s);

                i {
                    font-size: 0.75rem;
                    color: $atto-font-color;
                    width: 24px;
                    height: 24px;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 43px;
                    @include base-transition(ease color 0.15s);
                }

                &:hover {
                    color: $atto-green;

                    i {
                        color: $atto-green;
                    }
                }
            }

            &.seats {
                padding-bottom: 0;

            }
        }

        .content-wrapper {
            padding: 24px 48px 0 48px;
        }

        .modal-content {
            .modal-body {
                padding: 0;

                .content-wrapper {
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 8px;

                    p.seats-desc {
                        font-size: 0.875rem;
                        line-height: 1.25rem;
                        color: $atto-font-color;
                        font-family: $roboto-font;
                        font-weight: 400;
                        margin-bottom: 16px !important;

                        strong {
                            font-weight: bold;
                        }
                    }

                    .additional-seats-form {
                        margin-top: 0px;
                        padding-top: 16px;
                        padding-right: 48px;
                        position: relative;

                        &:before {
                            content: none;
                        }


                        .form-head {
                            display: flex;
                            padding: 5px 12px;
                            flex-direction: row;
                            border: 1px solid #EFEFEF;
                            background-color: #FAFAFA;
                            justify-content: space-between;

                            span {
                                font-size: 0.75rem;
                                line-height: 1.5rem;
                                font-family: "Roboto", sans-serif;
                                font-weight: 500;
                                color: $atto-not-active;
                            }
                        }

                        .form-fields .quickbooks {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            padding: 17px 12px;
                            border-bottom: 2px solid #efefef;

                            span {

                                display: inline-flex;
                                border: 0;
                                width: 94px;
                                font-size: 1rem;
                                line-height: 1.5rem;
                                color: #262626;
                                font-family: "Roboto", sans-serif;
                                justify-content: flex-end;

                                &:first-child {
                                    justify-content: flex-start;
                                }
                            }

                            input {
                                display: inline-flex;
                                border: 2px solid #efefef;
                                padding: 6px 12px;
                                width: 58px;
                                font-size: 1rem;
                                line-height: 1.5rem;
                                color: #262626;
                                font-family: "Roboto", sans-serif;
                                text-align: left !important;

                                /* Disabling Spinners */
                                -webkit-appearance: none;
                                -moz-appearance: textfield;
                                margin-right: 36px;

                                &::-webkit-inner-spin-button,
                                &::-webkit-outer-spin-button {
                                    -webkit-appearance: none;
                                    margin: 0;
                                }
                            }
                        }
                    }

                    &.seats {
                        padding-top: 8px;
                        padding-bottom: 0;

                        .head-labels {
                            .label {
                                &.email {
                                    width: 288px !important;
                                }
                            }
                        }

                        .ps {
                            max-height: calc(100vh - 550px);
                        }
                    }
                }
            }
        }

        .modal-footer {
            padding: 8px 40px 40px;
            display: flex;
            align-items: inherit;
            flex-direction: column!important;

            .alert-message {
                position: absolute;
                right: 48px;
                bottom: 12px;
                font-size: 0.875rem;
                line-height: 1.5rem;
                color: $atto-red;
                font-family: $roboto-font;
                font-weight: 400;
                margin: 0;
            }

            .form-disclaimer {
                display: flex;
                flex-direction: column;
                margin: 0;

                &.top {
                    margin: 4px 0 24px;
                    margin-left: auto;

                    p {
                        font-size: 0.75rem;
                        line-height: 1rem;
                        font-family: "Roboto", sans-serif;
                        font-weight: 400;
                        color: $atto-not-active;
                        margin-bottom: 0;
                    }
                }

                &.bottom {
                    margin-top: 16px;
                    width: 326px;
                    margin-left: auto;

                    p {
                        font-size: 0.625rem;
                        line-height: 0.875rem;
                        font-family: "Roboto", sans-serif;
                        font-weight: 400;
                        color: $atto-not-active;
                        text-align: right;
                        margin-bottom: 8px;
                        justify-content: flex-end;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .form-buttons {
                display: flex;
                flex-direction: row;
                margin: 0;

                .atto-btn {
                    flex-grow: 1;
                }
            }

            button.submit {
                margin-right: 0;
            }
        }
    }

    @media (max-width: 768px) {
        .modal-invite-member {
            max-width: 100% !important;
            margin: 0 auto !important;

            .modal-content {
                .modal-body {
                    .content-wrapper {
                        .additional-seats-form,
                        .ps {
                            padding-right: 0;
                        }

                        .role-wrap {
                            width: 100px;

                            .atto-select {
                                width: 100px;
                            }
                        }

                        p.seats-desc {
                            margin-bottom: 4px;
                        }
                    }

                    .modal-footer {

                        .form-buttons {
                            flex-direction: column;

                            button {
                                width: 100%;
                                margin-right: 0;
                                margin-bottom: 8px;

                                &.submit {
                                    order: -1;
                                }

                                &.cancel {
                                    margin-bottom: 0;
                                    margin-top: 0;
                                }
                            }


                        }
                    }
                }
            }


        }
    }
</style>